class TabsSection extends HTMLElement {
    constructor() {
        super();
        this.buttons = null;
        this.panels = null;
    }

    connectedCallback() {
        this.buttons = this.querySelectorAll('.image-with-tabs__tab-button');
        this.panels = this.querySelectorAll('.image-with-tabs__tab-panel');
        this.init();
    }

    init() {
        this.buttons.forEach((button, index) => {
            button.addEventListener('click', () => this.switchTab(index));
        });
    }

    switchTab(index) {
        this.buttons.forEach(btn => btn.classList.remove('active'));
        this.panels.forEach(panel => panel.classList.remove('active'));

        if (this.buttons[index]) {
            this.buttons[index].classList.add('active');
        }
        if (this.panels[index]) {
            this.panels[index].classList.add('active');
        }
    }
}

customElements.define('tabs-section', TabsSection);